import { managePartnerTabRoutes } from '@atlassian/mpac-utils';
import queryString from 'query-string';
import { reportNameToLabel } from "./ReportDetails.constants";
export const getReportBreadcrumb = (partnerId, partnerName, reportName, sourceParams, text) => {
  const links = managePartnerTabRoutes();
  return [{
    name: partnerName,
    href: links.baseRoute.expand({
      partnerId
    })
  }, {
    name: 'Reports',
    href: links.salesReports.expand({
      partnerId
    })
  }, {
    name: reportNameToLabel[reportName],
    href: "".concat(links.reports.expand({
      partnerId,
      reportName
    }), "?").concat(queryString.stringify(sourceParams))
  }, {
    name: text
  }];
};